import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-355b4446"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "float_connect" }
const _hoisted_2 = { class: "box_content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item i_phone" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
    /*#__PURE__*/_createElementVNode("span", null, "欢迎来电咨询"),
    /*#__PURE__*/_createElementVNode("span", { class: "text" }, "010-53655900")
  ])
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item i_mail" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
    /*#__PURE__*/_createElementVNode("span", null, "欢迎邮件咨询"),
    /*#__PURE__*/_createElementVNode("span", { class: "text" }, "market@galaxy-future.com")
  ])
], -1 /* HOISTED */))
const _hoisted_5 = { class: "item i_wechat" }
const _hoisted_6 = { class: "tip" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信扫码  在线咨询", -1 /* HOISTED */))
const _hoisted_9 = { class: "item i_experience" }
const _hoisted_10 = { class: "tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    alt: "",
                    src: $data.file.ImageQR
                  }, null, 8 /* PROPS */, _hoisted_7),
                  _hoisted_8
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.clickToStore()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" SaaS服务 ")
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}